import { GetInEmailStep } from '../../../component/auth/account/get-in/get-in-email-step'
import { GetInOtpStep } from '../../../component/auth/account/get-in/get-in-otp-step'
import { browserUtil, tokenService } from '../../../common'
import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import { mixpanelService } from 'src/service/mixpanel-service'

export const GetInScreen = (): React.ReactElement => {
  /**
   * Mixpanel for a signed-out visitor. `initiateApp()` never runs under `AuthLayout`, and its
   * `mixpanelService.init()` cannot run for a guest anyway — it calls `getMe()` on the authed
   * client. This mints the guest identifier that `alias` later joins to the account.
   */
  useEffect(() => {
    mixpanelService.initForGuest()
  }, [])

  if (tokenService.hasAccessToken()) {
    browserUtil.redirect('/')
    return <></>
  }

  /*
    The public featured workouts are NOT rendered here.

    They were, below the form — which is where the review found them, one full screen down,
    since both halves of the sign-in split are `min-h-screen`. They now live inside the two
    steps instead, so they are in the first screen on every viewport: the left column at `lg`
    and up (`featured-workouts-hero-panel.tsx`), a swipe rail under the logo below it
    (`featured-workouts-rail.tsx`). Both steps carry both, so someone waiting for their code
    still sees workouts.

    Neither placement reads account state — no `SessionContext`, no `useCatalogAccess`. Note
    this screen redirects a signed-in visitor to `/` below, so "not hidden for signed-in users"
    is unobservable here. That is NOT a defect: what the requirement protects is that the
    surface carries no account-state branching, and it does not. Do not add any, and do not
    "fix" the redirect. Everything on this path renders outside `SessionContext` and outside
    the authed axios client, which is why the card was built provider-free.
  */
  return (
    <Routes>
      <Route index element={<GetInEmailStep />} />
      <Route path="verify/:email" element={<GetInOtpStep />} />
    </Routes>
  )
}
